module.exports = __webpack_public_path__ + "img/ayom_yom_yes.913e887e.png";